"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _Overlay = _interopRequireDefault(require("./Overlay"));

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      data = _ref.data,
      dataProp = _ref.dataProp,
      trigger = _ref.trigger,
      _ref$requireNonEmptyS = _ref.requireNonEmptySearchTerm,
      requireNonEmptySearchTerm = _ref$requireNonEmptyS === void 0 ? true : _ref$requireNonEmptyS,
      _ref$maximumSearch = _ref.maximumSearch,
      maximumSearch = _ref$maximumSearch === void 0 ? 10 : _ref$maximumSearch,
      portalId = _ref.portalId,
      ResultsComponent = _ref.ResultsComponent,
      _ref$overlayPositioni = _ref.overlayPositioning,
      overlayPositioning = _ref$overlayPositioni === void 0 ? {
    placement: 'bottom right'
  } : _ref$overlayPositioni,
      _ref$transformData = _ref.transformData,
      transformData = _ref$transformData === void 0 ? _identity.default : _ref$transformData;

  return function (props) {
    return _react.default.createElement(_Overlay.default, Object.assign({}, props, {
      data: data,
      dataProp: dataProp,
      maximumSearch: maximumSearch,
      overlayPositioning: overlayPositioning,
      portalId: portalId,
      requireNonEmptySearchTerm: requireNonEmptySearchTerm,
      ResultsComponent: ResultsComponent,
      trigger: trigger,
      transformData: transformData
    }));
  };
};

exports.default = _default;
module.exports = exports.default;